import { $tickets } from "../services/Index";
import { $tickettype } from "../services/Index";
import { $group } from "../services/Index";
import { $agent } from "../services/Index";
import { $preferences } from "@core/services/";
import { $tag } from "@/services/Index";
import { mapGetters, mapMutations } from "vuex";
import { $filter } from "@/services/Index";
import DialogBox from "@core/components/ui/DialogBox"
import constants from "@core/config/constants";

/* eslint-disable */

export const ticketMixin = {
  components: {
    DialogBox
  },
  data() {
    return {
      statusList: [],
      priorityList: [],
      channelList: [],
      typeList: {
        list: [],
        pagination: {},
      },
      selectedTicketsData: [],
      closeDialog: false,
      closeReason: null,
      reasonList: ["resolved", "unresolved", "duplicate"],
      grouplist: {
        list: [],
        pagination: {},
      },
      itemsPerPage: 10,
      reference: null,
      itemsData: null,
      contactPageNo: 1,
      typePageNo: 1,
      agentList: [],
      searchAgentKeyword: null,
      loadCustomViews: 0,
      defaultItems: [
        {
          label: "All Tickets",
          isChecked: false,
          id: "all_tickets",
          name: "All Tickets",
          routerName: "tickets",
          filtername: "all-tickets",
        },
        {
          label: "My Tickets",
          isChecked: false,
          id: "my_tickets",
          name: "My Tickets",
          routerName: "my-tickets",
          filtername: "agent_id_in",
        },
        {
          label: "High Priority Tickets",
          isChecked: false,
          id: "high_priority_tickets",
          name: "High Priority Tickets",
          routerName: "high-priority-tickets",
          filtername: "priority_in",
        },
      ],
      searchTagKeyword: null,
      pagination:[],
      tagList:[],
      standardTabs: ['all_tickets', 'my_tickets', 'high_priority_tickets'],
      loading: false,
      headersMap: [
        {
          text: "Ticket#",
          align: "start",
          sortable: false,
          value: "id",
          width: "50px",
          show: true
        },
        { text: "Subject", value: "subject", class: "subject-col", show: true, width: "250px", disabled: true },
        { text: "Contact", value: "contact_name", width: "200px", show: true, disabled: true },
        { text: "Tags", sortable: false, value: "tags", width: "200px", show: false },
        {
          text: "Date Created",
          value: "created_at",
          align: "right",
          width: "250px",
          show: true
        },
        {
          text:"Last Response Date",
          value:"requesters_last_response_at",
          align:"right",
          width:"250px",
          show: false
        },
        {
          text: "Type",
          value: "ticket_type_name",
          width: "150px",
          align: "right",
          show: false
        },
        { text: "Channel", value: "channel", width: "140px", align: "right", show: false },
        { text: "Agent", value: "agent_name", width: "190px", align: "right", show: false },
        {
          text: "Status",
          value: "status",
          width: "100px",
          align: "right",
          show: true
        },
        { text: "Priority", value: "priority", width: "150px", align: "right", show: true },
        { 
          text: "",
          value: "action", 
          align: "right", 
          sortable: false, 
          show: true, 
          width: "5px",
          class: 'fixed'
        },
      ],
      loadComponent: false,
      ticketHeaders: [],
      headers: [],
      priorityColorCode: constants.PRIORITY_COLORS
    };
  },

  computed: {
    ...mapGetters({
      allTabs: 'filters/tabsView',
      currentTabs: 'filters/currentTabs',
      account: 'auth/account',
      selectedFilterId: 'tickets/selectedFilterId',
      filterMode: 'tickets/filterMode',
      savedFilterId: 'tickets/savedFilterId',
      tabsPreferences: 'filters/tabsPreferences',
      preferences:"auth/preferences",
      activeCustomViews: 'filters/activeCustomViews',
      filtersPage: 'filters/getFiltersPage',
      userTabsPreferences: 'filters/getUserPreferences',
    }),
    checkSelectedTicket() {
      if (this.selectedTicketsData.length !== 0) {
        return this.selectedTicketsData.length;
      } else {
        return 0;
      }
    },
    associatedField() {
      return this.$store.getters["tickets/associatedField"];
    },
    filteredTypesList() {
      return this.associatedField.types.list?.filter(type => type.name !== "--") || [];
    },
    filteredAgentList() {
      return this.associatedField.agentList?.filter(agent => agent.agent_name !== "--") || [];
    },
    currentLoggedInUserEmail() {
      return this.$store.getters["auth/userdata"].email;
    },
    ticketAccess () {
      return {
        // Close
        closed: this.ticketDetails.status === 'closed',
        // Soft Delete
        deleted: !!this.ticketDetails.deleted_at,
        // Access level
        permissions: {
          create: this.$can('create', 'tickets'),
        },
        // Contact Removed
        contactRemoved: !!this.ticketDetails.contact_email?.includes('pseudonymize.email')
      }
    },
    ticketAccess () {
      return {
        // Close
        closed: this.ticketDetails.status === 'closed',
        // Soft Delete
        deleted: !!this.ticketDetails.deleted_at,
        // Access level
        permissions: {
          create: this.$can('create', 'tickets'),
        },
        // Contact Removed
        contactRemoved: !!this.ticketDetails.contact_email?.includes('pseudonymize.email')
      }
    },
  },
  watch: {
    tabsPreferences: {
      handler: function (value) {
        this.loadCustomViews++
      },
      immediate: true
    },
    searchAgentKeyword(val) {
      this.pageNo = 1;
      this.getAgentList(val);
    },

    searchTagKeyword(val) {
      this.pageNo = 1;
      this.getTagsList(val);
    },
  },
  mounted() {
    //if (this.associatedField.agentList.length <= 1) {
    this.getAgentList();
    this.getStatusList();
    this.getPriorityList();
    this.getTicketTypes();
    this.getGroupList();
    this.getChannelList();
    this.getTagsList();
    //}
    this.agentList = this.associatedField.agentList;
    this.tagList = this.associatedField.tagList;
  },

  methods: {
    ...mapMutations({
      setTabsPreferences: "filters/setTabsPreferences",
    }),
    /* eslint-disable */
    async getStatusList() {
      try {
        const response = await $tickets.fetchStatusList({}, {});
        if (response.data) {
          this.statusList = response.data;
          this.statusList = this.statusList.map((item) => {
            return {
              name: item.name,
              value: item.value,
            };
          });
          this.$store.dispatch("tickets/statusList", [this.statusList]);
        }
      } catch (error) {}
    },

    /* eslint-disable */
    /**search agents and get list */
    async getAgentList(val = "", searchBy="") {
      this.$store.dispatch("tickets/agentList", []);
      let data = {
        page: 1,
        per_page: 10,
        q: {
          ...(searchBy && { id_in: val }),
          ...(!searchBy && { first_name_cont: val && val !== "--" ? val.split(" ")[0] : "" }),
          ...(!searchBy && { email_cont: val }),
          m: "or",
        },
      };
      try {
        const response = await $agent.searchList(data, {});
        if (response.data) {
          if(this.agentList && this.agentList.length > 0)
            this.agentList = [...response.data.agents, ...this.agentList];
          else 
            this.agentList = response.data.agents
          const uniqueIds = [];
          const uniqueAgents = this.agentList.filter((element) => {
            const isDuplicate = uniqueIds.includes(element.id);
            if (!isDuplicate) {
              uniqueIds.push(element.id);
              return true;
            }
            return false;
          });

          let dummyElement = { agent_name: "--", id: "blank" };
          uniqueAgents.forEach((item, index) => {
            if (item.id === "blank") {
              uniqueAgents.splice(index, 1);
            }
          });
          uniqueAgents.unshift(dummyElement);
          this.$store.dispatch("tickets/agentList", [uniqueAgents]);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getPriorityList() {
      try {
        const response = await $tickets.fetchPriorityList({}, {});
        if (response.data) {
          this.$store.dispatch("tickets/priorities", [response.data]);
        }
      } catch (error) {}
    },

    async getChannelList() {
      try {
        const response = await $tickets.fetchChannelList({}, {});
        if (response.data) {
          this.channelList = response.data;
          this.channelList = this.channelList.map((item) => {
            return {
              name: item.name,
              value: item.value,
            };
          });
          this.$store.dispatch("tickets/channelList", [this.channelList]);
        }
      } catch (error) {}
    },

    /* eslint-disable */
    async getGroupList() {
      let loadedGroups = this.$store.getters["tickets/groups"];
      const payload = {
        per_page: 10,
        page: this.contactPageNo,
      };
      try {
        const response = await $group.fetchList(payload, {});
        if (response.data) {
          if (this.contactPageNo == 1) {
            this.grouplist.list = response.data.groups;
          } else {
            this.grouplist.list = [
              ...loadedGroups.list,
              ...response.data.groups,
            ];
          }
          let dummyElement = { name: "--", id: "blank" };

          let dummyExist = false;
          this.grouplist.list.forEach((item) => {
            if (item.id === "blank") {
              dummyExist = true;
            }
          });
          if (!dummyExist) {
            this.grouplist.list.unshift(dummyElement);
          }
          this.grouplist.pagination = response.data.pagination;
          this.$store.dispatch("tickets/groups", [this.grouplist]);
        }
      } catch (error) {}
    },

    async getTicketTypes() {
      let loadedTypes = this.$store.getters["tickets/types"];
      const payload = {
        per_page: 10,
        page: this.typePageNo,
      };
      try {
        const response = await $tickettype.fetchList(payload, {});
        if (response.data) {
          if (this.typePageNo == 1) {
            this.typeList.list = response.data.ticket_types;
          } else {
            this.typeList.list = [
              ...loadedTypes.list,
              ...response.data.ticket_types,
            ];
          }
          let dummyElement = { name: "--", id: "blank" };
          let dummyExist = false;
          this.typeList.list.forEach((item) => {
            if (item.id === "blank") {
              dummyExist = true;
            }
          });
          if (!dummyExist) {
            this.typeList.list.unshift(dummyElement);
          }
          this.typeList.pagination = response.data.pagination;
          this.$store.dispatch("tickets/types", [this.typeList]);
        }
      } catch (error) {}
    },

    async performAction(data, key, value, action, name = "") {
      let ticketId = data.id;
      let payload = {
        ticket: {
          [key]: value,
        },
      };
      try {
        const response = await $tickets.update(payload, ticketId, {});
        if (response.data) {
          if (action == "close-btn") {
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Close Ticket",
                message: `Selected ${
                  this.checkSelectedTicket > 1 ? this.checkSelectedTicket : ""
                } ticket${
                  this.checkSelectedTicket > 1 ? "s" : ""
                } has been closed.`,
                type: "success",
              },
            ]);
          }
          if (name == "assign-ticket") {
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Assign Agent",
                message: `Agent has been assigned to selected ${
                  this.checkSelectedTicket > 1 ? this.checkSelectedTicket : ""
                } ticket${this.checkSelectedTicket > 1 ? "s" : ""}`,
                type: "success",
              },
            ]);
          }
          if (action == "index-page" || action == "close-btn") {
            this.checkRouterAndAppliedFilter();
          }

          if (action == "single-page") {
            this.$store.dispatch("ui/snackbar", [
              {
                title: "",
                message: `${name} updated successfully`,
                type: "success",
              },
            ]);
          }
        }
      } catch (error) {}
    },

    closeAction(data, action) {
      if (action == "update-status") {
        this.selectedTicketsData = [];
        this.closeReason = null;
        this.selectedTicketsData.push(data);
      }
      this.updateCloseDialog(true);
    },
    updateCloseDialog(value) {
      this.closeDialog = value
    },
    confirmClose() {
      this.selectedTicketsData.forEach((ticket) => {
        if (ticket.status !== "closed") {
          this.closeTicket(ticket);
        }
      });
    },

    async closeTicket(data) {
      let closeReason = "resolved";
      if (this.closeReason) {
        closeReason = this.closeReason;
      }
      let ticketId = data.id;

      let payload = {
        ticket: {
          status: "closed",
          closed_reason: closeReason,
        },
      };
      try {
        const response = await $tickets.update(payload, ticketId, {});
        if (response.data) {
          this.closeDialog = false;
          this.closeReason = "";

          this.$store.dispatch("ui/snackbar", [
            {
              title: "Close Ticket",
              message: `Selected ${
                this.checkSelectedTicket > 1 ? this.checkSelectedTicket : ""
              } ticket${
                this.checkSelectedTicket > 1 ? "s" : ""
              } has been closed.`,
              type: "success",
            },
          ]);
          this.checkRouterAndAppliedFilter();
        }
      } catch (error) {}
    },

    identifyFields(action) {
      this.reference = action;
    },

    /** scroll ticket index and details page type, groups, drop down  */
    indexItemsScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.itemsData = this.$store.getters["tickets/associatedField"];
        if (this.reference == "groups") {
          this.loadMoreGroups();
        }
        if (this.reference == "ticket_types") {
          this.loadMoreTicketTypes();
        }
      }
    },

    loadMoreGroups() {
      let existingGroup = this.$store.getters["tickets/groups"];
      if (
        existingGroup &&
        this.contactPageNo < existingGroup.pagination.page_count
      ) {
        this.contactPageNo += 1;
        this.getGroupList();
      }
    },

    loadMoreTicketTypes() {
      let existingTypes = this.$store.getters["tickets/types"];
      if (
        existingTypes &&
        this.typePageNo < existingTypes.pagination.page_count
      ) {
        this.typePageNo += 1;
        this.getTicketTypes();
      }
    },
    getPreferences() {
      this.loading = true
      $preferences.get().then((response) => {
        this.loading = false
        this.$store.commit("auth/setPreferences", response);
        let servicePreferences = response.service_cloud
        if (Object.keys(servicePreferences).length != 0) {
          this.$store.commit('filters/setUserPreferences', servicePreferences.tickets.tabs)
          const headersData = servicePreferences.tickets.headers;
          // Extracting the header name values from headers key
          const headerPreferences = headersData.map(header => header.name);
          this.headersMap.forEach(object => {
            object.show = headerPreferences.includes(object.value);
          });
          this.headers = headerPreferences
            .map(key => this.headersMap.find(item => item.value === key))
            .concat(this.filterAction);
          this.ticketHeaders = this.headersMap.filter(header => !headerPreferences.includes(header.value));
          this.ticketHeaders = this.headers.concat(this.ticketHeaders);
          this.loadComponent = true;
          //create tabs layout based on the active tabs in user preferences
          if(this.userTabsPreferences && this.userTabsPreferences.length > 0) {
            let customViewsId = this.userTabsPreferences?.filter(id => !this.standardTabs.includes(id)) || [];
            this.getEnabledCustomViews(customViewsId);
          } else {
            this.setDefaultTabs();
          }
          
        } else {
          //show default active columns and tabs
          this.setDefaultColumns();
          this.setDefaultTabs();
        }
      }).catch((e)=> {
        this.loading = false
        //show default active columns and tabs
        this.setDefaultColumns()
        this.setDefaultTabs();
      })
    },
    setDefaultColumns() {
      this.headers = this.headersMap.filter(header => header.show === true);
      this.ticketHeaders = this.headersMap
      this.loadComponent = true
    },
    getTabsPreferences() {
        this.pageLoader = false;
        const tabsView = this.allTabs;
        if (this.userTabsPreferences && this.userTabsPreferences.length != 0) {
            tabsView.forEach(object => {
              const tabId = object.id.toString()
              object.isChecked = this.userTabsPreferences.includes(tabId);
            });
            const activeTabs = this.userTabsPreferences
              .map(key => tabsView.find(item => item.id.toString() === key))
              .filter(tab => tab !== undefined);
            this.$store.commit("filters/setCurrentTabs", activeTabs);
            const remainingTabs =  tabsView.filter(item => !this.userTabsPreferences.includes(item.id.toString()))
            const orderedTabs = activeTabs.concat(remainingTabs);
            this.setTabsPreferences(orderedTabs)
        }
    },
    updateTabsPreferences(listItems) {
      const activeItems = listItems.filter(item => item.isChecked);
      const data = activeItems.map(value => value.id.toString());
      let payload = {
          "service_cloud": {
            "tickets": {
              "tabs": data
            }
          }
        }
      this.loader = true
      $preferences.update(payload, {}).then((response) => {
        this.loader = false
        this.cardOpen = false
        this.$store.commit("filters/setCurrentTabs", activeItems);
        this.$store.dispatch("ui/snackbar", [
          {
            message: "Preferences Update Successfully",
            type: "success",
          }
        ]);
        //navigate to the first tab item after update
        const activeTabItem = activeItems[0];
        this.refreshList();
        this.$router.push({ name: activeTabItem.routerName, params: { id: activeTabItem.id }}).catch(err => {});
      }).catch((e)=> {
        this.loader = false
        this.cardOpen = false
        this.$store.dispatch("ui/snackbar", [
          {
            message: 'Please try again',
            type: "error",
          }
        ]);
      })
    },
    getModified(tagName,maxLength) {
      return tagName.length > maxLength ? tagName.substring(0, maxLength) + '…' : tagName;
    },
    setDefaultTabs() {
      const items = this.defaultItems
      this.$store.commit("filters/setTabsView", items);
      //mark the first tab as active
      items[0].isChecked = true;
      this.$store.commit("filters/setCurrentTabs", [items[0]]);
      this.pageLoader = false
      this.setTabsPreferences(items)
    },

    async getTagsList(searchVal=""){
      this.$store.dispatch("tickets/tagList", []);
      const data = {
            page: 1,
            per_page: 10,
            q: {
              name_cont:searchVal,
              m: "or",
            },
      };
      try {
          const response = await $tag.fetchList(data, {});
          if (response.data) {
              if(this.tagList && this.tagList.length > 0){
                this.tagList=[...response.data.tag,...this.tagList]
              } else{
                this.tagList=[...response.data.tag]
              }
              const uniqueIds = [];
              this.tagList = this.tagList.filter((element) => {
                const isDuplicate = uniqueIds.includes(element.id);
                if (!isDuplicate) {
                  uniqueIds.push(element.id);
                  return true;
                }
                return false;
              });
              this.tagList.forEach(tag => {
                if (tag.name.length > 32) {
                    tag.name = tag.name.substring(0, 32);
                }
              });
              this.$store.dispatch("tickets/tagList", [this.tagList]);
          }
      } catch (error) {}
    },
    refreshList() {
      //reset current active views and filters
      this.setTabsPreferences([])
      this.$store.commit("filters/setTabsView", []);
      this.$store.commit("filters/setCurrentTabs", []);
      this.$store.commit("filters/setActiveCustomViews", []);
      this.$store.commit('filters/setFiltersPage', 0)
      this.$store.commit('filters/setLoadMoreFilters', true);
      this.getPreferences();
      
    },
    async getEnabledCustomViews(customViewIds=[]) {
      if(customViewIds.length === 0) {
        //get latest records for page=1
        this.$store.commit('filters/setFiltersPage', 1)
        await this.getSelectedCustomViews([], this.filtersPage);
      } else if(customViewIds.length !== 0 && customViewIds.length <= 10) {
        //get records specific to custom view Ids
        await this.getSelectedCustomViews(customViewIds, 1);
      } else {
        //in case of custom view more than 10, records need to be fetched pagewise
        let numberOfPages = Math.ceil(customViewIds.length / 10)
        for(let i=1; i<=numberOfPages; i++) {
          let sliceIndex = (i-1) * 10;
          await this.getSelectedCustomViews(customViewIds.slice(sliceIndex, sliceIndex+10), 1);
        }
      }
      const items = this.defaultItems.concat(this.activeCustomViews)
      this.$store.commit("filters/setTabsView", items);
      this.getTabsPreferences();
    },
    async getSelectedCustomViews(customViewIds, pageNumber) {
      this.pageLoader = true;
      try {
        const data = {
          q: { "id_in": customViewIds, page: pageNumber}
        };
        const response = await $filter.fetchList(data, {});
        if (response && response.data) {
          const filterViews = response.data.filters
          if(this.filtersPage === 1 && response.data.pagination.total_count<=10) {
            this.$store.commit('filters/setLoadMoreFilters', false)
          }
          const customFiltersList = filterViews.map((item) => {
            return {
              label: item.name,
              id: item.id,
              isChecked: false,
              name: item.name,
              routerName: "custom-view",
              filtername: "custom-view",
            }
          });
          let filters = []
          if(customViewIds.length > 0 && this.activeCustomViews.length > 0) {
            filters = this.activeCustomViews.concat(customFiltersList)
          } else {
            filters = customFiltersList
          }
          this.$store.commit("filters/setActiveCustomViews", filters)
        }  
      } catch (error) {
        this.pageLoader = false;
      }
    },
    // return active class for list
    activeListClass(ticketData,itemName, subItem ,fieldName){
      return ticketData[itemName] == subItem[fieldName] ? 'v-list-item--active': ''
    },

    // return priority color
    priorityColor(priority) {
      let colorCode = this.priorityColorCode.low
      if (priority == 'high') { colorCode = this.priorityColorCode.high }
      else if (priority == 'medium') { colorCode = this.priorityColorCode.medium }
      return colorCode
    }
  },
};
